import { MaterialDialog, styled } from '@ezbobdev/ui-widgets-ezbob';

export const StyledMaterialDialog = styled(MaterialDialog)`
  ${({ theme }) => {
    return `
    .MuiPaper-root {
      border-radius: 2.4rem;
    }
  
    .MuiDialogTitle-root {
      padding: 0.8rem 0rem;
    }
  
    .MuiDialogActions-root {
      flex-direction: column;
      gap: ${theme.spacing(1)};
  
      .MuiButton-root {
        max-width: 21.6rem;
        width: 100%;
      }
    }
    `;
  }}
`;
